import { useContext } from 'react';
import { ReactReduxContext } from 'react-redux';

/**
 * Имя текущего пользователя без подписки на стор — для ключей хранилища. Компонент рендерится и без redux
 * (тесты, стори) — тогда пустая строка.
 */
export const useOptionalUsername = (): string => {
    const redux = useContext(ReactReduxContext);
    return redux?.store.getState()?.auth?.user?.username ?? '';
};
